var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliDate", {
    attrs: {
      type: "month",
      noTitle: "",
      label: "Compare Month",
      clearable: "",
      "hide-details": "",
      max: _vm.max,
      value: _vm.value
        ? _vm.globalMomentUTCMonthYear(new Date(_vm.value))
        : null,
      rules: [],
      disabled: _vm.disabled,
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", {
          compareMonth: $event,
          compareYear: null,
        })
      },
      clear: function ($event) {
        return _vm.$emit("clear", {
          compareMonth: null,
          compareYear: null,
        })
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }